import React from 'react';

export default function UeberUns({ heading, text }) {
  return (
    <section style={styles.section}>
      <div style={styles.inner}>
        <div style={styles.textSide}>
          <span style={styles.eyebrow}>Unsere Geschichte</span>
          <h2 style={styles.heading}>{heading}</h2>
          <div style={styles.divider} />
          <p style={styles.text}>{text}</p>
        </div>
        <div style={styles.iconSide}>
          <div style={styles.iconBox}>
            <span style={styles.bigIcon}>🏕️</span>
            <div style={styles.iconStat}><strong>Familiengeführt</strong></div>
          </div>
          <div style={styles.iconBox}>
            <span style={styles.bigIcon}>🌄</span>
            <div style={styles.iconStat}><strong>Traumhafte</strong><span>Naturlage</span></div>
          </div>
          <div style={styles.iconBox}>
            <span style={styles.bigIcon}>❤️</span>
            <div style={styles.iconStat}><strong>Herzliche</strong><span>Gastgeber</span></div>
          </div>
        </div>
      </div>
    </section>
  );
}

const F = "'Inter', system-ui, sans-serif";

const styles = {
  section: { backgroundColor: 'white', padding: '5rem 1.5rem' },
  inner: { maxWidth: '1100px', margin: '0 auto', display: 'flex', gap: '4rem', alignItems: 'center', flexWrap: 'wrap' },
  textSide: { flex: '1 1 340px' },
  eyebrow: { fontSize: '0.75rem', fontFamily: F, fontWeight: '600', letterSpacing: '1.8px', textTransform: 'uppercase', color: '#1e8449' },
  heading: { color: '#1a1a1a', fontFamily: F, fontSize: 'clamp(1.6rem,4vw,2.3rem)', fontWeight: '700', marginTop: '0.5rem', marginBottom: '1rem', lineHeight: '1.2', letterSpacing: '-0.3px' },
  divider: { width: '40px', height: '3px', borderRadius: '2px', backgroundColor: '#1e8449', marginBottom: '1.2rem' },
  text: { color: '#6b7280', fontFamily: F, fontSize: '1rem', lineHeight: '1.8', whiteSpace: 'pre-wrap' },
  iconSide: { flex: '1 1 280px', display: 'flex', flexDirection: 'column', gap: '0.75rem' },
  iconBox: { display: 'flex', alignItems: 'center', gap: '1rem', backgroundColor: '#f8f9fa', borderRadius: '10px', padding: '1rem 1.25rem', border: '1px solid #e5e7eb' },
  bigIcon: { fontSize: '1.8rem', flexShrink: 0 },
  iconStat: { display: 'flex', flexDirection: 'column', fontFamily: F },
};
